import { render, staticRenderFns } from "./JtDoughnutChart.vue?vue&type=template&id=0024b934&scoped=true"
import script from "./JtDoughnutChart.vue?vue&type=script&lang=js"
export * from "./JtDoughnutChart.vue?vue&type=script&lang=js"
import style0 from "./JtDoughnutChart.vue?vue&type=style&index=0&id=0024b934&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0024b934",
  null
  
)

export default component.exports